import {
  parseConsumeStudentSelfInviteRequest,
  parseConsumeMemberInviteRequest,
  parseOwnerOnboardingConsumeRequest,
  parseAppMode,
  parseLineLoginRequest,
  parseUpdateMemberModeRequest,
  parseSessionResponse
} from "@madamuh/domain";
import type {
  AppMode,
  LineLoginRequestDto,
  ConsumeMemberInviteRequestDto,
  ConsumeStudentSelfInviteRequestDto,
  OwnerOnboardingConsumeRequestDto,
  SessionResponseDto,
  UpdateMemberModeRequestDto
} from "@madamuh/domain";
import { apiGet, apiPatch, apiPost } from "./client";

export async function fetchCurrentSession(): Promise<SessionResponseDto> {
  const response = await apiGet<unknown>("/api/v1/session/me");
  return parseSessionResponse(response);
}

export async function postLineLogin(request: LineLoginRequestDto): Promise<SessionResponseDto> {
  const parsedRequest = parseLineLoginRequest(request);
  const response = await apiPost<LineLoginRequestDto, unknown>("/api/v1/session/line-login", parsedRequest);
  return parseSessionResponse(response);
}

export async function patchMemberMode(
  tenantSlug: string,
  mode: AppMode
): Promise<SessionResponseDto> {
  const parsedRequest = parseUpdateMemberModeRequest({ mode: parseAppMode(mode) });
  const response = await apiPatch<UpdateMemberModeRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/member-mode`,
    parsedRequest
  );
  return parseSessionResponse(response);
}

export async function postOwnerOnboardingConsume(
  tenantSlug: string,
  token: string
): Promise<SessionResponseDto> {
  const parsedRequest = parseOwnerOnboardingConsumeRequest({ token });
  const response = await apiPost<OwnerOnboardingConsumeRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/owner-onboarding/consume`,
    parsedRequest
  );
  return parseSessionResponse(response);
}

export async function postMemberInviteConsume(
  tenantSlug: string,
  token: string
): Promise<SessionResponseDto> {
  const parsedRequest = parseConsumeMemberInviteRequest({ token });
  const response = await apiPost<ConsumeMemberInviteRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/member-invites/consume`,
    parsedRequest
  );
  return parseSessionResponse(response);
}

export async function postStudentSelfInviteConsume(
  tenantSlug: string,
  token: string
): Promise<SessionResponseDto> {
  const parsedRequest = parseConsumeStudentSelfInviteRequest({ token });
  const response = await apiPost<ConsumeStudentSelfInviteRequestDto, unknown>(
    `/api/v1/app/tenants/${tenantSlug}/student-self-invites/consume`,
    parsedRequest
  );
  return parseSessionResponse(response);
}
